'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    BasicPagination: ()=>BasicPagination
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../Button/index.cjs");
const external_IconButton_index_cjs_namespaceObject = require("../../IconButton/index.cjs");
const external_Select_index_cjs_namespaceObject = require("../../Select/index.cjs");
const external_Tooltip_index_cjs_namespaceObject = require("../../Tooltip/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_Label_index_cjs_namespaceObject = require("../../Label/index.cjs");
const BasicPagination = ({ showButtonLabels = false, pageCountDisplay = 'none', initialPage = 1, rowsPerPage, totalRows, onPageChange, className })=>{
    const [currentPage, setCurrentPage] = (0, external_react_namespaceObject.useState)(initialPage);
    const totalPages = (0, external_react_namespaceObject.useMemo)(()=>Math.ceil(totalRows / rowsPerPage), [
        totalRows,
        rowsPerPage
    ]);
    const pageNumbers = (0, external_react_namespaceObject.useMemo)(()=>Array.from({
            length: totalPages
        }, (_, index)=>index + 1), [
        totalPages
    ]);
    const handlePageSelectChange = (0, external_react_namespaceObject.useCallback)((value)=>{
        onPageChange?.(parseInt(value, 10));
    }, [
        onPageChange
    ]);
    const pageSelectMenuItems = (0, external_react_namespaceObject.useMemo)(()=>pageNumbers.map((num)=>({
                label: num.toString(),
                value: num.toString()
            })), [
        pageNumbers
    ]);
    const renderPageCountDisplay = (0, external_react_namespaceObject.useMemo)(()=>{
        switch(pageCountDisplay){
            case 'label':
                return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Label_index_cjs_namespaceObject.Label, {
                    className: "whitespace-nowrap",
                    children: [
                        currentPage,
                        " of ",
                        totalPages
                    ]
                });
            case 'select':
                return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Select_index_cjs_namespaceObject.Select, {
                            label: "",
                            placeholder: "Page",
                            menuItems: pageSelectMenuItems,
                            value: currentPage.toString(),
                            initialValue: currentPage.toString(),
                            onChange: handlePageSelectChange,
                            className: "w-24"
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Label_index_cjs_namespaceObject.Label, {
                            className: "whitespace-nowrap",
                            children: [
                                "of ",
                                totalPages
                            ]
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {});
        }
    }, [
        currentPage,
        totalPages,
        pageSelectMenuItems,
        pageCountDisplay,
        handlePageSelectChange
    ]);
    const handlePreviousPageClick = (0, external_react_namespaceObject.useCallback)(()=>{
        onPageChange?.(Math.max(1, currentPage - 1));
        setCurrentPage(Math.max(1, currentPage - 1));
    }, [
        onPageChange,
        currentPage
    ]);
    const handleNextPageClick = (0, external_react_namespaceObject.useCallback)(()=>{
        onPageChange?.(Math.min(totalPages, currentPage + 1));
        setCurrentPage(Math.min(totalPages, currentPage + 1));
    }, [
        onPageChange,
        currentPage,
        totalPages
    ]);
    const previousButton = showButtonLabels ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
        iconLeft: "chevron_left",
        type: "tertiary",
        onClick: handlePreviousPageClick,
        disabled: currentPage <= 1,
        children: "Previous"
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
        iconName: "chevron_left",
        type: "plainPrimary",
        onClick: handlePreviousPageClick,
        disabled: currentPage <= 1
    });
    const nextButton = showButtonLabels ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
        iconRight: "chevron_right",
        type: "tertiary",
        onClick: handleNextPageClick,
        disabled: currentPage >= totalPages,
        children: "Next"
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
        iconName: "chevron_right",
        type: "plainPrimary",
        onClick: handleNextPageClick,
        disabled: currentPage >= totalPages
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: (0, external_utils_index_cjs_namespaceObject.cn)('flex flex-row items-center gap-2', className),
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                side: "top",
                color: "neutral",
                emphasis: true,
                triggerNode: previousButton,
                children: "Previous Page"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Label_index_cjs_namespaceObject.Label, {
                className: "hidden [.advanced-pagination_&]:block",
                children: "Page"
            }),
            renderPageCountDisplay,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Tooltip_index_cjs_namespaceObject.Tooltip, {
                side: "top",
                color: "neutral",
                emphasis: true,
                triggerNode: nextButton,
                children: "Next Page"
            })
        ]
    });
};
exports.BasicPagination = __webpack_exports__.BasicPagination;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BasicPagination"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
